import { ErrorResponse, ResetPasswordSuccessResponse } from '../../types/auth'
import { callApi } from '../../utils/api'
import { endpoints } from '../config'

type ResetPasswordProps = {
  guid: string
  newPassword: string
}

export const resetPassword = async ({
  guid,
  newPassword
}: ResetPasswordProps): Promise<ResetPasswordSuccessResponse | ErrorResponse<'Unauthorized'> | null> => {
  const response = await callApi<ResetPasswordSuccessResponse | ErrorResponse<'Unauthorized'>>({
    path: `${endpoints.resetPassword}?${new URLSearchParams({ guid, passwort: newPassword }).toString()}`
  })

  if (!response.data) {
    return null
  }

  if (!response.isOk && 'status' in response.data && response.data.status === 'Unauthorized') {
    return response.data as ErrorResponse<'Unauthorized'>
  }

  return response.data as ResetPasswordSuccessResponse
}
